import { Component } from '@angular/core';

import { EXPERIENCE_CARDS } from '../app-launcher.models';
import { AppLauncherStateService } from '../app-launcher-state.service';

@Component({
	selector: 'sd-landing',
	templateUrl: './landing.component.html',
})
export class LandingComponent {
	public readonly experienceCards = EXPERIENCE_CARDS;
	public email = this.state.accountEmail;

	constructor(public readonly state: AppLauncherStateService) {}

	public start(): void {
		this.state.startFromLanding(this.email);
	}

	public startAppLauncher(): void {
		this.state.goTo('login');
	}
}
